// src/pages/MLmatePage.tsx — MLmate: learn ML by watching it run.
// The map/drawer app lives in src/mlmate/ (ported from the standalone
// MLmate repo); this page wraps it with the Cubemate sidebar and scopes
// its dark theme. Backend: /api/mlmate (all tiers, no credit charge).
import React from 'react';
import Sidebar from '../components/Sidebar';
import MLmateApp from '../mlmate/MLmateApp';
import '../mlmate/mlmate.css';

const MLmatePage: React.FC = () => {
  return (
    <div className="h-screen flex overflow-hidden">
      <Sidebar />
      <div className="mlmate-page flex-1 min-w-0 overflow-hidden">
        <MLmateApp />
      </div>
    </div>
  );
};

export default MLmatePage;
